import Create from './component';

export default Create;
